import { Component, OnInit, Input, ContentChild, TemplateRef, ViewChildren, ViewContainerRef, QueryList, ContentChildren, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { HasFormComponent } from '../../../core/interfaces/hasFormComponent';
import { Observable, Subscription } from 'rxjs';
import { SaveState } from '../ndms-panel-form/ndms-panel-form.component';
import { BaseFormViewModel } from '../../view-models/base-form.view-model';
import { NdmsConfirmService } from '../../../core/services/ndms-confirm.service';
import {EventEmitter, Inject, Injectable} from "@angular/core";

@Component({
  selector: 'ndms-panel-form-multiple',
  templateUrl: './ndms-panel-form-multiple.component.html',
  styleUrls: ['./ndms-panel-form-multiple.component.scss']
})
export class NdmsPanelFormMultipleComponent implements OnInit {

  @Input() label: string;
  @Input() group: FormGroup;
  @Input() array: string;
  @Input() colSize: number;
  @Input() isEditing: boolean;
  @Input() readOnlyAfterSave: boolean;
  @Input() refreshWatch: EventEmitter<any>;
  @Input() public editEnabled: boolean = true;
  @Input() service: any;
  @Input() saveFnName: string;
  @Input() deleteFnName: string;
  @Input() customDeleteFnName: string;
  @Input() additionalBtnName: string;
  @Input() additionalBtnFnName: string;

  //addNew: boolean;
  isSaving: boolean;
  SaveState = SaveState;
  formSaveState: SaveState;

  public activeEditingKey: string;
  private newlyAddedKey: string;

  private activeEditingFormGroup: FormGroup;
  private activeEditingInitValue: any;
  private activeEditingIndex: number;
  private hasFormComponent: HasFormComponent<any>;

  private controlLength: number = 0;

  public currentArrayControlArrays: AbstractControl[][]
  private sub: Subscription;
  @ContentChild(TemplateRef) formGroupOrControlTemplate: TemplateRef<any>;

  constructor(
    vcRef: ViewContainerRef,
    private _ndmsConfirmService: NdmsConfirmService
  ) {
    this.hasFormComponent = (<any>vcRef.injector).view.component;
    
  }

  ngOnInit() {
    this.currentArrayControlArrays = this.calculateArrayControls();
    if(this.refreshWatch)
      this.sub = this.refreshWatch.subscribe(()=>{
        this.currentArrayControlArrays = this.calculateArrayControls();
      });
  }
  ngOnDestroy(){
    if(this.sub){
      this.sub.unsubscribe();
    }
  }
  /*
    This ngDoCheck() is here to make sure that we update the view when the form group changes.
    For example, for the responder profile where we fetch the data after you expand 
    the panel, we need to update the panel with the fetched data
  */

  ngDoCheck() {
    if(!this.group.get(this.array)) return;

    if(this.controlLength != (this.group.get(this.array) as FormArray).length) {
      this.currentArrayControlArrays = this.calculateArrayControls();
    }
  }

  calculateArrayControls() {
    let acas: AbstractControl[][] = [];
    if(!this.group.get(this.array)) return;
    if ((this.group.get(this.array) as FormArray)) {
      let arrayControls = (this.group.get(this.array) as FormArray).controls.slice();
      this.controlLength = arrayControls.length;

      while (arrayControls.length > 0) {
        acas.push(arrayControls.splice(0, this.colSize));
      }
    }
    return acas;
  }

  getArrayControls() {
    return this.currentArrayControlArrays || [];
  }

  isSingleEditing(key: string) {
    return this.activeEditingKey == key;
  }

  setActiveKey(key: string) {
    this.activeEditingKey = key;
  }

  onEditSingle(key: string, row: number, col: number) {
    this.setActiveKey(key);

    this.activeEditingIndex = this.calculateIndexFromRowCol(row, col);
    this.activeEditingFormGroup = (this.group.get(this.array) as FormArray).at(this.activeEditingIndex) as FormGroup;
    this.activeEditingInitValue = this.activeEditingFormGroup.value;
  }

  onCancelItemClick() {
    if(!this.group.get(this.array)) return;

    if (this.activeEditingKey == this.newlyAddedKey) {
      let formArrayControls: FormArray = (this.group.get(this.array) as FormArray);
      formArrayControls.removeAt(formArrayControls.length - 1)
      this.currentArrayControlArrays = this.calculateArrayControls();
    }
    else {
      this.activeEditingFormGroup.setValue(this.activeEditingInitValue);
    }

    this.activeEditingKey = '';
  }

  onAdditionalBtnClick() {
    if(console) console.log('onAdditionalBtnClick...');
    (this.service[this.additionalBtnFnName]( this.activeEditingKey ) as Observable<any>).subscribe(
      () => {
      },
      () => {
      },
      () => {
      }
      );
  }

  onEditClick() {
    this.isEditing = true;
    //this.addNew = false ;
  }

  onCancelClick() {
    this.isEditing = false;
    console.log(this.group.value);
    this.formSaveState = this.SaveState.IDLE;
  }

  onAddNewClick() {
    this.activeEditingFormGroup = this.addToArray();
    //this.addNew = true ;
  }

  private isFormGroupValid() {
    for (let key of Object.keys(this.activeEditingFormGroup.controls)) {
      let control = this.activeEditingFormGroup.get(key);
      let isValid = (control as FormControl) ? (control as FormControl).valid : true;
      if (!isValid) {
        return false;
      }
    }
    return true;
  }

  onSaveItemClick() {
    if (!this.isFormGroupValid()) {
      Object.keys(this.activeEditingFormGroup.controls).forEach(key => {
        let control = this.activeEditingFormGroup.get(key);
        if (control) {
          control.markAsTouched();
        }
      });
      return;
    }
    let currentEditingKey = this.activeEditingKey;
    let updatedFormGroup = this.activeEditingFormGroup.value;
    updatedFormGroup.key = this.group.get('key')!.value;
    this.isSaving = true;
    (this.service[this.saveFnName](updatedFormGroup) as Observable<any>).subscribe(
      (savedViewModelFormGroup: FormGroup | FormGroup[]) => {
        this.formSaveState = this.SaveState.SUCCESS;

        setTimeout(() => {
          this.activeEditingKey = "";
          this.isSaving = false;
          this.formSaveState = this.SaveState.IDLE;
          if(Array.isArray(savedViewModelFormGroup))
          {
            let prevControls = this.group.get(this.array) as FormArray;
            while (0 !== prevControls.length) {
              prevControls.removeAt(0);
            }
            savedViewModelFormGroup.forEach(function(item: FormGroup) {
              prevControls.push(item);
            });
            this.currentArrayControlArrays = this.calculateArrayControls();
          } else {
            //This line forces a square peg (identifier view model) into a round hole (this form, which has slightly different fields)
            //and we get an error because the forms don't match. Besides that, this line is unnecessary: activeEditingFormGroup
            //already contains the updated identifier - the user just typed it in and clicked save. There's no
            //reason to bend over backwards backfilling the same value into the form it just came from to begin with.

            //This is a safe change because this component is only used for wristband editing. So as long as wristband still works,
            //we should be fine doing whatever we want here. And this line already didn't DO anything - it failed on error and aborted.

            //This may need revisiting once we come back to fix the duplication issue, but more likely it will just make sense to
            //build a fresh component without all the baggage of this one.

            /*this.activeEditingFormGroup.setValue(savedViewModelFormGroup.value);*/
          }
        }, 1000);
      },
      () => {
        this.activeEditingKey = currentEditingKey;
        this.isSaving = false;
        this.formSaveState = this.SaveState.ERROR;
      });
  }

  onCustomDeleteItemClick(){
    let currentEditingKey = this.activeEditingKey;
    let deletedFormGroupValue = this.activeEditingFormGroup.value;
    (this.service[this.customDeleteFnName](deletedFormGroupValue) as Observable<any>).subscribe(
      () => {
        /*
        this.formSaveState = this.SaveState.SUCCESS;
        setTimeout(() => {
          this.activeEditingKey = "";
          this.isSaving = false;
          this.formSaveState = this.SaveState.IDLE;
          (this.group.get(this.array) as FormArray).removeAt(this.activeEditingIndex);
          this.currentArrayControlArrays = this.calculateArrayControls();
        }, 1000)
        */
      },
      () => {
        /*
        this.activeEditingKey = currentEditingKey;
        this.isSaving = false;
        this.formSaveState = this.SaveState.ERROR;
        */
      });
  }
  
  onDeleteItemClick(){
    this._ndmsConfirmService.delete('', () => this.onDeleteItemClickFn())
  }
  
  onDeleteItemClickFn() {
    let currentEditingKey = this.activeEditingKey;

    let deletedFormGroup = this.activeEditingFormGroup.value;
    deletedFormGroup.key = this.group.get('key')!.value;

    this.isSaving = true;
    (this.service[this.deleteFnName](deletedFormGroup) as Observable<any>).subscribe(
      () => {
        this.formSaveState = this.SaveState.SUCCESS;

        setTimeout(() => {
          this.activeEditingKey = "";
          this.isSaving = false;
          this.formSaveState = this.SaveState.IDLE;
          (this.group.get(this.array) as FormArray).removeAt(this.activeEditingIndex);
          this.currentArrayControlArrays = this.calculateArrayControls();
        }, 1000)
      },
      () => {
        this.activeEditingKey = currentEditingKey;
        this.isSaving = false;
        this.formSaveState = this.SaveState.ERROR;
      });
  }
  addToArray() {
    let formArrayControls: FormArray = (this.group.get(this.array) as FormArray);

    const formArrayDefaultObject = this.hasFormComponent.formArrayDefaultObjectRegistry[this.array];

    if (!formArrayDefaultObject) {
      throw ("Must register default array type for field: '" + this.array + "' for this form.");
    }

    let addedFormGroupOrControl = formArrayDefaultObject()
    formArrayControls.push(addedFormGroupOrControl);
    this.currentArrayControlArrays = this.calculateArrayControls();

    this.activeEditingKey = this.newlyAddedKey = this.calculateKey(formArrayControls.length);

    return addedFormGroupOrControl;
  }

  private calculateKey(length: number) {
    if (length % this.colSize > 0) {
      return 'row' + Math.floor(length / this.colSize) + 'col' + ((length % this.colSize) - 1);
    }
    else {
      return 'row' + Math.floor((length - 1) / this.colSize) + 'col' + (this.colSize - 1);
    }
  }

  private generateKey(row: number, col: number): string {
    return 'row' + row + 'col' + col;
  }

  private getSingleItemClass() {
    return 'col-md-' + (12 / this.colSize);
  }

  private calculateIndexFromRowCol(row: number, col: number): number {
    return row * this.colSize + col;
  }
}
